import { Main } from '@sl/base/logic/slots/main';

export class Default extends Main { 
    constructor(scene) {
        super(scene);
        this.preparedAnimations = {};
        this.overspinSprite = 'flares';
        this.spinningReels = {};

        if(this.reelsAnimations && this.reelsAnimations.overspins) {
            if(!Array.isArray(this.reelsAnimations.overspins)) {
                const copy_overspins = this.reelsAnimations.overspins;
                this.reelsAnimations.overspins = [];
                this.reelsAnimations.overspins.push(copy_overspins);
            }
        }
    }

    moveReels() {
        if(this.spinStarted) {
            for(const [ reelIndex, reel ] of Object.entries(this.reelsContainersObjects)) {
                if(reel.spinning) {
                    this.moveReel(reelIndex, reel);
                }
            }
        }
    }

    moveReel(reelIndex, reel) {
        this.spinningReels[reelIndex] = this.spinningReels[reelIndex].filter((val) => { return val });

        if(!reel.finalSpin && !reel.symbolsToStop && Object.keys(this.scene.request.scenario).length) {
            reel.symbolsToStop = [];
            
            for(let i = -1; i < this.spinningRowsCount-1; i++) {
                const index = this.scene.request.scenario.reels[reelIndex]+i;
                const symbolIndex = this.getAfterSymbolIndex(reel.reelIndex, index);

                reel.symbolsToStop.unshift(symbolIndex);
            }

        }

        this.spinningReels[reelIndex].forEach((symbol, arrayIndex)  => {
            this.moveSymbol(reel, symbol.indexOnReel, arrayIndex);
        });
    }

    moveSymbol(reel, symbolIndex, arrayIndex) {
        if(!reel.spinning) {
            return;
        }

        const symbol = reel.symbols[symbolIndex];

        if(!symbol.spinning) {
            return;
        }

        if(this.currentSpinSpeed > this.symbolHeight) {
            this.currentSpinSpeed = this.symbolHeight - 10;
        }

        let finalPosition = this.getSymbolCoordinateY(this.visibleRowsCount, symbol);
        let stopCoo = finalPosition;

        let moveTo = 0;
 
        moveTo = symbol.y + this.currentSpinSpeed;

        if(symbol.stopPosition !== undefined && moveTo > symbol.stopPosition) {
            stopCoo = symbol.stopPosition;
        } 
        
        if(moveTo > stopCoo) {
            moveTo = stopCoo;
        }

        symbol.y = moveTo;

        if(symbol.stopPosition !== undefined && symbol.y == symbol.stopPosition) {
            symbol.spinning = false;
            symbol.setScale(1, 1);
            reel.symbolsStopped++;

            if(reel.symbolsStopped === 1) {
                reel.offsetPosition = this.scene.request.scenario.reels[reel.reelIndex];
                reel.reelStartsAt = this.scene.request.scenario.reels[reel.reelIndex];
            }

            if(reel.symbolsStopped == this.visibleRowsCount+2) {
                if(!this.preparedAnimations[reel.reelIndex+1] 
                    || !this.preparedAnimations[reel.reelIndex+1]['overspins']) {
                    reel.stopped = true;
                }

                this.spinningReels[reel.reelIndex] = this.spinningReels[reel.reelIndex].filter((val) => { return val });

                reel.spinning = false;
                symbol.stopPosition = undefined;

                this.spinningReels[reel.reelIndex].forEach((symbol, arrayIndex)  => {
                    symbol.stopPosition = undefined;
                    symbol.spinning = true;
                });
                
                this.playStopAnimation(reel.reelIndex, reel);

                this.unblurSymbols(reel);

                return;
            }
        }

        symbol.setFrame(this.symbolBlurFrame);
        symbol.setScale(this.spinningScaleX, this.spinningScaleY)

        if(symbol.y >= finalPosition) {
            let skipped = -1;
            let nextIndex = this.getAfterSymbolIndex(reel.reelIndex, this.getLastSpinningSymbol(reel.reelIndex).indexOnReel);

            if(!reel.finalSpin) {
                while(reel.symbolsToStop && reel.symbolsToStop.includes(nextIndex)) {
                    nextIndex = this.getAfterSymbolIndex(reel.reelIndex, this.getLastSpinningSymbol(reel.reelIndex).indexOnReel + skipped);
                    skipped--;
                }
            } else {
                nextIndex = reel.symbolsToStop[0];
                reel.symbolsToStop.shift();
            }
            
            let nextSymbol = reel.symbols[nextIndex];

            symbol.spinning = false;
            symbol.stopPosition = undefined;
            delete this.spinningReels[reel.reelIndex][arrayIndex];

            const timePassed = ((new Date().getTime() - this.spinStartedAt) / 1000);
            
            if(reel.symbolsToStop
                && (reel.reelIndex === 1 || this.reelsContainersObjects[reel.reelIndex-1].stopped)
                && !reel.finalSpin 
                && (timePassed > 1 || (timePassed > 0.3 && this.currentSpinSpeed > this.initialSpinSpeed))) {

                let tryToStop = true; 

                if(this.preparedAnimations && this.preparedAnimations[reel.reelIndex] && !this.resetSlot) {
                    if(this.preparedAnimations[reel.reelIndex]['overspins']) {
                        if(this.holdOverSpin(reel.reelIndex)) {
                            tryToStop = false;
                        } else {
                            if(reel.overspin) {
                                this.overspinAnimation(reel.reelIndex);
                            }

                            if(reel.overspin) {
                                tryToStop = false;
                            }
                        }
                    }
                }

                this.spinningReels[reel.reelIndex].forEach((currentSymbol, arrayIndex)  => {
                    if(reel.symbolsToStop.includes(currentSymbol.indexOnReel)) {
                        tryToStop = false;
                    }
                });

                if(tryToStop) {
                    reel.finalSpin = true;
                }
            }

            this.prepareNextSymbol(reel, nextIndex, nextSymbol);

            return;
        }
    }

    prepareNextSymbol(reel, nextIndex, nextSymbol) {
        if(!nextSymbol.spinning) {
            let positionOnReel = nextSymbol.sizeOnReel > 1 ? -(nextSymbol.sizeOnReel)-1 : -2;

            nextSymbol.positionOnReel = positionOnReel;
            let prevSymbol = this.getLastSpinningSymbol(reel.reelIndex);

            let needed_position = (prevSymbol.y-(this.symbolHeight * prevSymbol.sizeOnReel / 2)) - this.symbolHeight / 2;
            
            if(nextSymbol.sizeOnReel > 1) {
                needed_position = ((prevSymbol.y + this.symbolHeight / 2) + ((nextSymbol.sizeOnReel - prevSymbol.appended - 1) * this.symbolHeight)) - (this.symbolHeight*nextSymbol.sizeOnReel / 2);
            }

            nextSymbol.y = needed_position;

            if(reel.spinning) {
                nextSymbol.y += this.currentSpinSpeed;
            }

            nextSymbol.spinning = true;

            if(reel.stoppingReel) {
                nextSymbol.stopPosition = this.getSymbolCoordinateY(reel.symbolsLeftForStop-1, nextSymbol);

                if(reel.symbolsLeftForStop === -1 && nextSymbol.y > nextSymbol.stopPosition) {
                    nextSymbol.y = nextSymbol.stopPosition;
                    nextSymbol.spinning = false;
                }

                reel.symbolsLeftForStop--;
            }

            this.spinningReels[reel.reelIndex].push(nextSymbol);
            
            if(reel.finalSpin && !reel.stoppingReel) {
                reel.stoppingReel = true;
            }
        }

        if(!nextSymbol.appended) {
            nextSymbol.alpha = 1;
        } 
        
        /*if(nextSymbol.appended) {
            const appendedIndex = this.getAfterSymbolIndex(reel.reelIndex, nextIndex);
            const appendedSymbol = reel.symbols[appendedIndex];
            this.prepareNextSymbol(reel, appendedIndex, appendedSymbol);
        }*/
    }

    holdOverSpin(reelIndex) {
        if((this.reelsContainersObjects[reelIndex-1] && this.reelsContainersObjects[reelIndex-1].spinning) 
            || (this.preparedAnimations[reelIndex-1] 
            && this.preparedAnimations[reelIndex-1]['overspins']
            && this.reelsContainersObjects[reelIndex-1].spinning
            && (this.reelsContainersObjects[reelIndex-1].overspin || !this.reelsContainersObjects[reelIndex-1].overspinDone))) {
                return true;
        }

        return false;
    }

    overspinAnimation(reelIndex) {
        var overspinReel = this.reelsContainersObjects[reelIndex];

        if(!overspinReel.overspin) {
            overspinReel.startedAt = new Date().getTime();
            overspinReel.overspin = parseInt(this.reelsAnimations.overspins[0].count);
            overspinReel.overspinDone = false;

            if(this.overspinSound) {
                this.overspinSound.play();
            }

            if(typeof this.scene.overspinAnimationConfig === 'function') {
                overspinReel.overspinObject = this.scene.add.particles(this.overspinSprite);
                this.frameContainerFront.add(overspinReel.overspinObject);
                overspinReel.overspinObject.createEmitter(this.scene.overspinAnimationConfig(overspinReel));
            }

            if(typeof this.scene.overspinAnimation === 'function') {
                overspinReel.overspinObject = this.scene.overspinAnimation(overspinReel);
                this.frameContainerFront.add(overspinReel.overspinObject);
            }
        }

        if(this.reelsAnimations.overspins.fadeOutOthers) {
            for(const [ index, reel ] of Object.entries(this.reelsContainersObjects)) {
                if(overspinReel.overspin == parseInt(this.reelsAnimations.overspins[0].count)) {
                    if(reelIndex !== parseInt(index)) {
                        reel.background.alpha = 0.4;
                    } else {
                        reel.background.alpha = 0;
                    }
                }
            }
        }

        const timePassed = ((new Date().getTime() - overspinReel.startedAt) / 1000);
        
        if(timePassed >= 1) {
            overspinReel.overspin--;
        }

        /*if(!overspinReel.overspin) {
            overspinReel.overspinDone = true;
            overspinReel.overspinObject.destroy();
        }*/
    }

    createReels() {
        let offsetX = this.symbolsOffsetX();

        this.reelsContainer = this.scene.add.container();
        this.reelsContainer.x = this.scene.cameras.main.centerX;
        this.reelsContainer.y = 0;

        if(this.symbolsFade) {
            let sprite = this.scene.add.sprite(this.frame.x + this.symbolsFadeOffsetX, this.frame.y + this.symbolsFadeOffsetY, this.symbolsFade).setOrigin(0.5, 0.5);
            sprite.name = this.symbolsFade;
            sprite.alpha = 0;
            this.reelsContainer.add(sprite);
        }

        for (const [ reelIndex, reel ] of Object.entries(this.reels)) {
            this.reelsContainersObjects[reelIndex] = {'symbols':[]};
            this.reelsContainersObjects[reelIndex].reelIndex = parseInt(reelIndex);
            this.reelsContainersObjects[reelIndex].spinned = 0;
            this.reelsContainersObjects[reelIndex].initialPositions = {};
            let positionOnReel = 0;
            this.reelsContainersObjects[reelIndex].reelStartsAt = 0;
            let appended = 0;

            if(this.underSymbolsReel) {
                this.underSymbolsReelItems[reelIndex] = this.scene.add.sprite(offsetX, this.reelsOffsetTop, this.underSymbolsReel).setOrigin(0.5, 0.5);
                this.underSymbolsReelItems[reelIndex].alpha = 0;
                this.reelsContainer.add(this.underSymbolsReelItems[reelIndex]);
            }

            for (const [ symbolIndex, symbol ] of Object.entries(reel)) {
                const symbolSprite = this.createSymbolSprite(reelIndex, reel, symbolIndex, symbol, appended);

                if(symbolSprite.sizeOnReel > 1) {
                    appended = symbolSprite.sizeOnReel;
                }

                symbolSprite.positionOnReel = positionOnReel;
                symbolSprite.symbolKey = reel[symbolIndex];

                symbolSprite.y = this.getSymbolCoordinateY(positionOnReel, symbolSprite);
                symbolSprite.x = offsetX;
  
                this.reelsContainer.add(symbolSprite);
                this.reelsContainersObjects[reelIndex].symbols.push(symbolSprite);

                if(this.visibleRowsCount >= positionOnReel) {
                    if(!symbolSprite.appended) {
                        symbolSprite.alpha = 1;
                    } else {
                        symbolSprite.alpha = 0;
                    }

                    if(this.visibleRowsCount > positionOnReel) {
                        symbolSprite.spinning = true;

                        if(!this.spinningReels[reelIndex]) {
                            this.spinningReels[reelIndex] = [];
                        }
                        
                        this.spinningReels[reelIndex].unshift(symbolSprite);
                    }

                    positionOnReel++;
                }

                if(parseInt(symbolIndex) === reel.length-1 ) {
                    this.prepareNextSymbol(this.reelsContainersObjects[reelIndex], symbolIndex, symbolSprite);
                    let symbolAfterIndex = this.getAfterSymbolIndex(reelIndex, symbolIndex);
                    let symbolAfter = this.getAfterSymbol(reelIndex, symbolIndex);
                    this.prepareNextSymbol(this.reelsContainersObjects[reelIndex], symbolAfterIndex, symbolAfter);
                }

                if(appended) {
                    appended--;
                }
            }
            
            this.reelsContainersObjects[reelIndex].offsetPosition = 0;
            this.reelsContainersObjects[reelIndex].x = offsetX;
            this.reelsContainersObjects[reelIndex].y = this.reelsOffsetTop;
            this.reelsContainersObjects[reelIndex].name = `reel_${reelIndex}`;
            //this.frameContainer.add(this.reelsContainersObjects[reelIndex]);
            //this.reelsContainer.add(this.reelsContainersObjects[reelIndex]);

            offsetX += this.spaceBetweenReels + this.symbolWidth;
        }

        this.createReelsMask();
    }

    opacityBeforeSpin(targets) {
        targets.forEach((symbol, arrayIndex)  => {
            symbol.alpha = 1;

            if(typeof this.scene.smallFramesLayerUp === 'function' && this.scene.staticFrames[symbol.reelIndex][symbol.positionOnReel]) {
                this.scene.smallFramesLayerUp(symbol.reelIndex, symbol.positionOnReel);
            }
        });
    }

    getAnimationTargets(reel) {
        let targets = [];

        for(let i = 0; i < this.spinningRowsCount-1; i++) {
            const index = reel.offsetPosition+i;
            const symbol = this.getAfterSymbol(reel.reelIndex, index);

            if(symbol.appended && symbol.append_parent) {
                targets.push(symbol.append_parent);
            } else {
                targets.push(symbol);
            }
        }

        return targets;
    }

    startSpinReel(reelIndex, reel, delay) {
        this.scene.time.delayedCall(delay, () => {this.scene.playStopSound();}, {}, this);

        let targets = this.getAnimationTargets(reel);

        this.opacityBeforeSpin(targets);
        
        this.scene.tweens.add({
            targets,
            y: (target, targetKey, value, targetIndex, totalTargets, tween) => {
                return target.y- this.initialAnimationStep;
            },
            ease: 'Power0',
            duration: this.initialAnimationSpeed,
            yoyo: 0,
            repeat: 0,
            delay: delay,
            onComplete: () => {
                this.scene.tweens.add({
                    targets,
                    y: (target, targetKey, value, targetIndex, totalTargets, tween) => {
                        return target.y + this.initialAnimationStep;
                    },
                    ease: 'Power0',
                    duration: this.initialAnimationSpeed / 2,
                    yoyo: 0,
                    repeat: 0,
                    onComplete: () => {
                        reel.spinning = true;
                        this.reelsSpinning++;
                        if(this.reelsContainersObjects[reelIndex].spinAnimationEmitter) {
                            this.reelsContainersObjects[reelIndex].spinAnimationEmitter.start();

                            this.scene.time.delayedCall(500, () => {this.reelsContainersObjects[reelIndex].spinAnimationEmitter.stop()}, {}, this);
                        }

                        if(this.reelsSpinning === Object.keys(this.reelsContainersObjects).length) {
                            this.scene.playSpinSound();
                        }
                    },
                });
            },
        });
    }

    playStopAnimation(reelIndex, reel) {
        let targets = this.getAnimationTargets(reel);
        this.fixToFinalPositions(reel);

        this.scene.tweens.add({
            targets,
            y: (target, targetKey, value, targetIndex, totalTargets, tween) => {
                return target.y + this.stopAnimationStep;
            },
            ease: 'Expo.easeOut',
            duration: this.stopAnimationSpeed,
            yoyo: 0,
            repeat: 0,
            onComplete: () => {
                if(typeof this.scene.customStopAnimation === 'function') {
                    this.scene.customStopAnimation(reelIndex);
                }

                this.scene.playStopSound();
                
                this.scene.tweens.add({
                    targets,
                    y: (target, targetKey, value, targetIndex, totalTargets, tween) => {
                        return target.y - this.stopAnimationStep;
                    },
                    ease: 'Power0',
                    duration: this.stopAnimationSpeed,
                    yoyo: 0,
                    repeat: 0,
                    onComplete: () => {
                        if(typeof this.scene.afterReelStop === 'function') {
                            this.scene.afterReelStop(reel);
                        }

                        this.reelsSpinning--;
                        this.prepareNextOverspin(reel)
                        reel.stopped = true;

                        if(!this.reelsSpinning) {
                            this.spinStarted = false;
                            this.scene.request.spinStopped();
                            this.scene.muteSpinSound();
                            this.scene.afterSpin();
                            this.afterSpin();
                        }
                    },
                });
            },
        });
    }

    prepareNextOverspin(reel) {
        if (this.resetSlot) {
            return;
        }

        if(this.preparedAnimations) {
            if(this.reelsAnimations && this.reelsAnimations.overspins.fadeOutOthers) {
                for(const [ index, currentReel ] of Object.entries(this.reelsContainersObjects)) {
                    currentReel.background.alpha = 0;
                }
            }

            if(this.preparedAnimations[reel.reelIndex] && this.preparedAnimations[reel.reelIndex]['overspins']) {
                reel.overspinDone = true;

                if(this.overspinSound) {
                    this.overspinSound.stop();
                }
                
                reel.overspinObject.destroy();
            }
            
            if(this.preparedAnimations[reel.reelIndex+1] 
                && this.preparedAnimations[reel.reelIndex+1]['overspins']) {
                this.overspinAnimation(reel.reelIndex+1);
            }
        }
    }

    update() {
        if(this.spinStarted) {
            this.moveReels();
        }
    }

    prepareReels() {
        this.currentSpinSpeed = this.initialSpinSpeed;
        if(this.speed) {
            this.speedUpSpin();
        }

        this.changeOpacityOfSymbols(0);
        
        for(const [ reelIndex, reel ] of Object.entries(this.reelsContainersObjects)) {
            reel.finalSpin = false;
            reel.symbolsStopped = 0;
            reel.stoppingReel = false;
            reel.symbolsToStop = false;
            reel.stopped = false;
            reel.symbolsLeftForStop = this.visibleRowsCount+1;
            let delay = reelIndex * this.startTimeoutBetweenReels;

            this.startSpinReel(reelIndex, reel, delay);
        }

        this.spinStartedAt = new Date().getTime();
    }

    afterSpin() {
        if(this.preparedAnimations) {
            for(const [ reelIndex, reel ] of Object.entries(this.reelsContainersObjects)) {
                if(this.preparedAnimations[reelIndex] &&
                    this.preparedAnimations[reelIndex]['overspins']) {
                    reel.overspinDone = false;
                }
            }
        }
    }

    prepareAnimations(scenario) {
        this.preparedAnimations = {};

        if(this.reelsAnimations && this.reelsAnimations.overspins && !scenario.freespins && !scenario.bonus_stage) {
            this.luckyOverspin = false;

            for(const [ overspinIndex, overspin ] of Object.entries(this.reelsAnimations.overspins)) {
                let symbolsCounts = {};
                
                for(const [ reelIndex, symbolIndex ] of Object.entries(scenario.reels)) {
                    if(symbolsCounts[overspin.symbol] === overspin.from) {
                        this.thereIsOverspin = true;
                        this.preparedAnimations[reelIndex] = {'overspins':overspin.count};
                    }
                    
                    if(symbolsCounts[overspin.symbol] === overspin.count) {
                        this.luckyOverspin = true;
                    }

                    for(let i = 0; i < this.visibleRowsCount; i++) {
                        let symbol = this.getSymbolAt(reelIndex, parseInt(symbolIndex)+i);
                        if(!symbolsCounts[symbol.symbolName]) {
                            symbolsCounts[symbol.symbolName] = 1;
                        } else {
                            symbolsCounts[symbol.symbolName]++;
                        }
                    }
                }
            }
        }
    }
}